module.exports = __webpack_public_path__ + "img/login_logo@2x.86cd7e0f.png";